import { MAIN_MENU_COLLAPSED_LOCAL_STORAGE_KEY } from "constants/shared";

export const getMainMenuCollapsedFromLocalStorage = () => {
  const value = localStorage.getItem(MAIN_MENU_COLLAPSED_LOCAL_STORAGE_KEY);
  return value ? JSON.parse(value) : false;
};
export const setMainMenuCollapsedToLocalStorage = (value: boolean) => {
  localStorage.setItem(MAIN_MENU_COLLAPSED_LOCAL_STORAGE_KEY, JSON.stringify(value));
};
export const deleteMainMenuCollapsedFromLocalStorage = () => {
  localStorage.removeItem(MAIN_MENU_COLLAPSED_LOCAL_STORAGE_KEY);
};
